// extracted by mini-css-extract-plugin
export default {"content":"errorPage_content__-1rOn","subtitle":"errorPage_subtitle__HR6bk"};